import type { AdminPermission, AdminRole } from '~/models/admin-role';
import { useAuthStore } from '~/store/auth';

// Template helpers. The auth store owns the rules.

export function hasPermission(permission: AdminPermission | AdminPermission[]): boolean {
  return useAuthStore().hasPermission(permission);
}

export function canWritePage(path: string): boolean {
  return useAuthStore().canWritePage(path);
}

export function canDeleteOnPage(path: string): boolean {
  return useAuthStore().canDeleteOnPage(path);
}

/** Built-in roles store a fixed code as the name, so the admin site shows its translation. */
export function adminRoleName(role: Pick<AdminRole, 'name' | 'is_built_in'>): string {
  const { t } = useNuxtApp().$i18n;
  return role.is_built_in ? t(`enums.admin_built_in_role.${role.name}`, role.name) : role.name;
}
